<template>
    <div class="learncoin-section">
        <output-learncoin-manage
            :showOperate="false"
            :tradeTypes="tradeTypes"
            :custom-params="{ accountType: 2, accountCode: '' }"/>
    </div>

</template>
<script>
    import outputLearncoinManage from '@/modules/knowledge-operation/share-output/output-learncoin-manage/index.vue';

    export default {
        data: () => ({
            tradeTypes: [
                { id: 0, text: '全部' },
                { id: 6, text: '会员卡' },
                { id: 7, text: '课程' },
                { id: 8, text: '专题' },
                { id: 1, text: '分配' },
                { id: 3, text: '订阅' },
                { id: 4, text: '打赏' },
            ],
        }),
        components: {
            outputLearncoinManage,
        },
    };
</script>
<style lang="less" scoped>
.learncoin-section{
    /deep/ .manage-wrapper{
        background-color:#fff;
    }
}
</style>
